{
	"submitTitle": "Seleccionar material",
	"summary": {
		"title": "Resumen",
		"declarationTypeTitle": "Tipo de declaración",
		"projectReferenceTitle": "Referencia del proyecto"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Seleccione el tipo de declaración",
			"customerProject": {
				"title": "Proyecto de cliente",
				"description": "El material se utilizó para un proyecto externo. Ahora necesito proporcionar una declaración que detalle las reducciones de carbono para mi cliente."
			},
			"internalProjectOrProduct": {
				"title": "Proyecto/producto interno",
				"description": "El material se utilizó para un proyecto o producto interno. Necesito crear una declaración para reclamar las reducciones de carbono para nuestras propias operaciones."
			}
		},
		"addProjectReferenceSection": {
			"title": "Agregar referencia del proyecto",
			"subTitle": "Debe asignar reducciones de carbono a una referencia de proyecto para la que desea crear la declaración.",
			"projectReferencePlaceholder": "Referencia del proyecto"
		},
		"selectProjectSection": {
			"title": "Seleccione un proyecto",
			"createNewProjectPlaceholder": "Crear nuevo proyecto"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Se requiere tipo de declaración",
		"projectReferenceRequired": "Se requiere referencia del proyecto",
		"fetchProjectsError": "No se pudieron recuperar proyectos anteriores"
	}
}
